// Test IDs for the internal admin panel (LOCCITEC operations team).
export const ADMIN = {
  // Layout
  sidebarDashboardLink: 'admin-sidebar-dashboard-link',
  sidebarUnidadesLink: 'admin-sidebar-unidades-link',
  sidebarClientesLink: 'admin-sidebar-clientes-link',
  sidebarEmbarquesLink: 'admin-sidebar-embarques-link',
  sidebarNotificacionesLink: 'admin-sidebar-notificaciones-link',
  sidebarPlantillasLink: 'admin-sidebar-plantillas-link',
  sidebarEtapasLink: 'admin-sidebar-etapas-link',
  sidebarTiposLink: 'admin-sidebar-tipos-link',
  sidebarCuentaLink: 'admin-sidebar-cuenta-link',
  sidebarLogoutButton: 'admin-sidebar-logout-button',
  userRoleBadge: 'admin-user-role-badge',
  mobileMenuButton: 'admin-mobile-menu-button',
  sidebarCloseButton: 'admin-sidebar-close-button',
  sidebarOverlay: 'admin-sidebar-overlay',

  // Login
  loginEmailInput: 'admin-login-email-input',
  loginPasswordInput: 'admin-login-password-input',
  loginSubmitButton: 'admin-login-submit-button',
  loginError: 'admin-login-error',
  loginForgotPasswordLink: 'admin-login-forgot-password-link',

  // Mi cuenta (cambiar contraseña)
  cuentaCurrentPasswordInput: 'admin-cuenta-current-password-input',
  cuentaNewPasswordInput: 'admin-cuenta-new-password-input',
  cuentaConfirmPasswordInput: 'admin-cuenta-confirm-password-input',
  cuentaSubmitButton: 'admin-cuenta-submit-button',
  cuentaError: 'admin-cuenta-error',
  cuentaSuccess: 'admin-cuenta-success',

  // Dashboard
  dashboardStageCard: 'admin-dashboard-stage-card',
  dashboardTotalActive: 'admin-dashboard-total-active',
  dashboardTotalDelivered: 'admin-dashboard-total-delivered',
  dashboardRecentRow: 'admin-dashboard-recent-row',

  // Unidades list
  unidadesSearchInput: 'admin-unidades-search-input',
  unidadesFilterCliente: 'admin-unidades-filter-cliente',
  unidadesFilterEtapa: 'admin-unidades-filter-etapa',
  unidadesFilterTipo: 'admin-unidades-filter-tipo',
  unidadesNewButton: 'admin-unidades-new-button',
  unidadesRow: 'admin-unidades-row',
  unidadesPaginationPrev: 'admin-unidades-pagination-prev',
  unidadesPaginationNext: 'admin-unidades-pagination-next',
  unidadesEmptyState: 'admin-unidades-empty-state',

  // Unidad form
  unidadFormVin: 'admin-unidad-form-vin-input',
  unidadFormTipo: 'admin-unidad-form-tipo-select',
  unidadFormMarca: 'admin-unidad-form-marca-input',
  unidadFormModelo: 'admin-unidad-form-modelo-input',
  unidadFormAnio: 'admin-unidad-form-anio-input',
  unidadFormColor: 'admin-unidad-form-color-input',
  unidadFormCliente: 'admin-unidad-form-cliente-select',
  unidadFormOrigen: 'admin-unidad-form-origen-input',
  unidadFormDestino: 'admin-unidad-form-destino-input',
  unidadFormPuertoOrigen: 'admin-unidad-form-puerto-origen-input',
  unidadFormPuertoDestino: 'admin-unidad-form-puerto-destino-input',
  unidadFormBuque: 'admin-unidad-form-buque-input',
  unidadFormBooking: 'admin-unidad-form-booking-input',
  unidadFormPedidoCliente: 'admin-unidad-form-pedido-cliente-input',
  unidadFormFactura: 'admin-unidad-form-factura-input',
  unidadFormFechaEntrega: 'admin-unidad-form-fecha-entrega-input',
  unidadFormTelefonoNotif: 'admin-unidad-form-telefono-notif-input',
  unidadFormEmailNotif: 'admin-unidad-form-email-notif-input',
  unidadFormConsentimiento: 'admin-unidad-form-consentimiento-checkbox',
  unidadFormConsentimientoOrigen: 'admin-unidad-form-consentimiento-origen-input',
  unidadFormSubmit: 'admin-unidad-form-submit-button',
  unidadFormCancel: 'admin-unidad-form-cancel-button',
  unidadFormError: 'admin-unidad-form-error',
  unidadesExportButton: 'admin-unidades-export-button',

  // Unidad detail (admin)
  detalleAdvanceButton: 'admin-detalle-advance-button',
  detalleManualEventButton: 'admin-detalle-manual-event-button',
  detalleEditUnidadButton: 'admin-detalle-edit-unidad-button',
  detalleEventRow: 'admin-detalle-event-row',
  detalleEventEditButton: 'admin-detalle-event-edit-button',
  detalleEventDeleteButton: 'admin-detalle-event-delete-button',
  detalleNotificacionRow: 'admin-detalle-notificacion-row',
  detalleNotificacionRetryButton: 'admin-detalle-notificacion-retry-button',
  eventDialogEtapa: 'admin-event-dialog-etapa-select',
  eventDialogFecha: 'admin-event-dialog-fecha-input',
  eventDialogNota: 'admin-event-dialog-nota-textarea',
  eventDialogSubmit: 'admin-event-dialog-submit-button',

  // Photos
  photoDropzone: 'admin-photo-dropzone',
  photoFileInput: 'admin-photo-file-input',
  photoItem: 'admin-photo-item',
  photoDeleteButton: 'admin-photo-delete-button',
  photoMoveUpButton: 'admin-photo-move-up-button',
  photoMoveDownButton: 'admin-photo-move-down-button',
  photoUploadProgress: 'admin-photo-upload-progress',
  photoLeyendaInput: 'admin-photo-leyenda-input',
  photoTomadaEnInput: 'admin-photo-tomada-en-input',
  photoEditButton: 'admin-photo-edit-button',
  photoEditLeyenda: 'admin-photo-edit-leyenda-input',
  photoEditTomadaEn: 'admin-photo-edit-tomada-en-input',
  photoEditSubmit: 'admin-photo-edit-submit-button',

  // Clientes
  clientesNewButton: 'admin-clientes-new-button',
  clientesRow: 'admin-clientes-row',
  clientesEditButton: 'admin-clientes-edit-button',
  clientesToggleActivoButton: 'admin-clientes-toggle-activo-button',
  clientesDeleteButton: 'admin-clientes-delete-button',
  clienteFormNombre: 'admin-cliente-form-nombre-input',
  clienteFormSlug: 'admin-cliente-form-slug-input',
  clienteFormTelefono: 'admin-cliente-form-telefono-input',
  clienteFormEmail: 'admin-cliente-form-email-input',
  clienteFormConsentimiento: 'admin-cliente-form-consentimiento-checkbox',
  clienteFormConsentimientoOrigen: 'admin-cliente-form-consentimiento-origen-input',
  clienteFormSubmit: 'admin-cliente-form-submit-button',
  clienteFormError: 'admin-cliente-form-error',

  // Destinatarios de notificación (Fix D, 2026-09-01) - compartido entre Clientes y UnidadForm
  destinatarioRow: 'admin-destinatario-row',
  destinatarioNombre: 'admin-destinatario-nombre-input',
  destinatarioTelefono: 'admin-destinatario-telefono-input',
  destinatarioEmail: 'admin-destinatario-email-input',
  destinatarioConsentimiento: 'admin-destinatario-consentimiento-checkbox',
  destinatarioOrigen: 'admin-destinatario-origen-input',
  destinatarioRemoveButton: 'admin-destinatario-remove-button',
  destinatarioAddButton: 'admin-destinatario-add-button',
  destinatariosWhatsappGroupNote: 'admin-destinatarios-whatsapp-group-note',

  // Shared confirm dialog
  confirmDialogConfirm: 'admin-confirm-dialog-confirm-button',
  confirmDialogCancel: 'admin-confirm-dialog-cancel-button',

  // Forbidden (403)
  forbidden: 'admin-forbidden-page',
  forbiddenBackLink: 'admin-forbidden-back-link',

  // Usuarios
  sidebarUsuariosLink: 'admin-sidebar-usuarios-link',
  usuariosNewButton: 'admin-usuarios-new-button',
  usuariosRow: 'admin-usuarios-row',
  usuariosEditButton: 'admin-usuarios-edit-button',
  usuariosToggleActivoButton: 'admin-usuarios-toggle-activo-button',
  usuarioFormNombre: 'admin-usuario-form-nombre-input',
  usuarioFormEmail: 'admin-usuario-form-email-input',
  usuarioFormPassword: 'admin-usuario-form-password-input',
  usuarioFormRol: 'admin-usuario-form-rol-select',
  usuarioFormCliente: 'admin-usuario-form-cliente-select',
  usuarioFormSubmit: 'admin-usuario-form-submit-button',
  usuarioFormError: 'admin-usuario-form-error',

  // Plantillas de notificación
  plantillasRow: 'admin-plantillas-row',
  plantillasEditButton: 'admin-plantillas-edit-button',
  plantillaFormTexto: 'admin-plantilla-form-texto-textarea',
  plantillaFormVariableChip: 'admin-plantilla-form-variable-chip',
  plantillaFormWhatsappNombre: 'admin-plantilla-form-whatsapp-nombre-input',
  plantillaFormWhatsappIdioma: 'admin-plantilla-form-whatsapp-idioma-select',
  plantillaFormWhatsappParamChip: 'admin-plantilla-form-whatsapp-param-chip',
  plantillaFormWhatsappParamAdd: 'admin-plantilla-form-whatsapp-param-add',
  plantillaFormWhatsappParamRemove: 'admin-plantilla-form-whatsapp-param-remove',
  plantillaFormSubmit: 'admin-plantilla-form-submit-button',

  // Notificaciones (historial)
  notificacionesSearchInput: 'admin-notificaciones-search-input',
  notificacionesFilterEstado: 'admin-notificaciones-filter-estado',
  notificacionesFilterCanal: 'admin-notificaciones-filter-canal',
  notificacionesRow: 'admin-notificaciones-row',
  notificacionesRetryButton: 'admin-notificaciones-retry-button',
  notificacionesEmptyState: 'admin-notificaciones-empty-state',

  // Etapas (activar/desactivar + renombrar)
  etapasRow: 'admin-etapas-row',
  etapasEditButton: 'admin-etapas-edit-button',
  etapasToggleButton: 'admin-etapas-toggle-button',
  etapaFormNombre: 'admin-etapa-form-nombre-input',
  etapaFormDescripcion: 'admin-etapa-form-descripcion-input',
  etapaFormSubmit: 'admin-etapa-form-submit-button',

  // Tipos de unidad
  tiposRow: 'admin-tipos-row',
  tiposNewButton: 'admin-tipos-new-button',
  tiposEditButton: 'admin-tipos-edit-button',
  tiposDeleteButton: 'admin-tipos-delete-button',
  tipoFormNombre: 'admin-tipo-form-nombre-input',
  tipoFormIcono: 'admin-tipo-form-icono-select',
  tipoFormSubmit: 'admin-tipo-form-submit-button',
  tipoFormError: 'admin-tipo-form-error',

  // Importación masiva de unidades (Fix C, 2026-09-01)
  unidadesImportButton: 'admin-unidades-import-button',
  unidadesImportFotosButton: 'admin-unidades-import-fotos-button',
  importDropzone: 'admin-import-dropzone',
  importFileInput: 'admin-import-file-input',
  importSampleLink: 'admin-import-sample-link',
  importColumnSelect: 'admin-import-column-select',
  // Fix G (2026-09-10): campos con los que el operador completa lo que la planilla
  // Yard Booking del cliente deja vacío (Categoría, Color, Año).
  importDefaultTipo: 'admin-import-default-tipo',
  importDefaultColor: 'admin-import-default-color',
  importDefaultAnio: 'admin-import-default-anio',
  importClientesNuevos: 'admin-import-clientes-nuevos',
  importAnalyzeButton: 'admin-import-analyze-button',
  importProblemsTable: 'admin-import-problems-table',
  importProblemRow: 'admin-import-problem-row',
  importConfirmButton: 'admin-import-confirm-button',
  importResultSummary: 'admin-import-result-summary',
  importResultVin: 'admin-import-result-vin',
  importEmbarqueLink: 'admin-import-embarque-link',
  importBackButton: 'admin-import-back-button',
  importError: 'admin-import-error',

  // Carga masiva de fotos por VIN (Fix C, 2026-09-01)
  importFotosDropzone: 'admin-import-fotos-dropzone',
  importFotosFileInput: 'admin-import-fotos-file-input',
  importFotosPreviewRow: 'admin-import-fotos-preview-row',
  importFotosUploadButton: 'admin-import-fotos-upload-button',
  importFotosProgress: 'admin-import-fotos-progress',
  importFotosResultSummary: 'admin-import-fotos-result-summary',

  // Embarques (agrupación por booking)
  embarquesFilterCliente: 'admin-embarques-filter-cliente',
  embarquesRow: 'admin-embarques-row',
  embarquesEmptyState: 'admin-embarques-empty-state',
  embarqueDetalleAdvanceButton: 'admin-embarque-detalle-advance-button',
  embarqueDetalleSelectAllCheckbox: 'admin-embarque-detalle-select-all-checkbox',
  embarqueDetalleRowCheckbox: 'admin-embarque-detalle-row-checkbox',
  embarqueDetalleRow: 'admin-embarque-detalle-row',
  embarqueDetalleResultDialog: 'admin-embarque-detalle-result-dialog',
  videosSection: 'admin-videos-section',
  videoLinkCreate: 'admin-video-link-create',
  videoLinkUrl: 'admin-video-link-url',
  videoLinkCopy: 'admin-video-link-copy',
  videoLinkRevoke: 'admin-video-link-revoke',
  videoLinkRow: 'admin-video-link-row',
  videoDelete: 'admin-video-delete',
};
